/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Review Component Styles
 *
 * @file ReviewComponentStyle.jsx
 * @author Murhsid Ahamedh
 */

import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../../assets/styles/mixins.scss';
import CommonStyles from '../../../assets/styles/CommonStyles';

const useReviewComponentStyles = makeStyles({
  reviewCardRoot: {
    backgroundColor: '#EFEEF7'
  },
  containerStyle: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  reviewContentStyle: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,

    [mixins['mlg-min']]: {
      flexDirection: 'row'
    }
  },
  actionsLeftContainer: {
    width: 'auto'
  },
  leftAccordionListMenuPaper: {
    maxHeight: '500px',
    ...CommonStyles().scrollContainer(
      {
        scrollbarColor: 'rgba(81, 46, 171, 0.15) transparent',
        scrollbarWidth: 8
      }
    ),

    '& *': {
      boxSizing: 'border-box'
    },
    borderRadius: 12
  },
  leftAccordionListMenuList: {
    minWidth: 342
  },
  titleStyle: {
    fontFamily: `${mixins.fontFamilyPlusSans}, sans-serif`,
    fontWeight: mixins.fontWeight600,
    fontStyle: 'normal',
    fontSize: mixins.fontSize28,
    lineHeight: mixins.lineHeight150,
    letterSpacing: '-0.02em',
    verticalAlign: 'middle',
    marginBottom: 8
  },

  leftColStyle: {
    width: 280,

    [mixins['mlg-min']]: {
      flex: '0 0 280px'
    }
  },

  rightColStyle: {
    flex: 1
  }
});

export default useReviewComponentStyles;
